export default __webpack_public_path__ + "static/media/A4_31.c88cd5cc.mp3";